/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from '@angular/core';

import { Subject, Subscription } from "rxjs";

import { WebSocketService } from "./websocket.service";
import { DialogNotificationService } from "./dialog-notification.service";
import { Url_WebSocket_BuildUrl } from "app/rest-constants";
import { DialogInstance } from "../models/dialog-instance";

@Injectable()
export class DialogWebSocketService {

  private mDialogInstanceEventListeners = new Subject<DialogInstance>();
  private dialogOnDemandEventListeners = new Subject<DialogInstance>();

  private mSubject: Subject<MessageEvent> = null;
  private mSubscription: Subscription = null;

  constructor(
    private mWebSocketService: WebSocketService,
    private mDialogNotificationService: DialogNotificationService
  ) {}

  public getDialogInstanceEventListeners(): Subject<DialogInstance> {
    return this.mDialogInstanceEventListeners;
  }

  public getDialogInstanceOnDemandEventListeners(): Subject<DialogInstance> {
    return this.dialogOnDemandEventListeners;
  }

  public async refreshDialogWebSocket(authToken: string): Promise<void> {
    console.log("Refreshing Dialog Web Socket... Auth Token: " + authToken + ", Subject: " + this.mSubject);

    //Close the Web Socket if it is currently open...
    if (this.mSubject != null || this.mSubscription != null) {
      console.log("Disconnecting from Dialog WS...");
      if (this.mSubscription != null) {
        this.mSubscription.unsubscribe();
        this.mSubscription = null;
      }
      if (this.mSubject != null) {
        this.mSubject.unsubscribe();
        this.mSubject = null;
      }
    }

    //If there is a User logged into the System (Auth Token passed), create / connect the Web Socket
    if (authToken != null) {
      console.log("Connecting to Dialog WS...");

      //Build the WS URL
      const url = Url_WebSocket_BuildUrl(authToken, "user");

      //Create the RX/JS Subject to connect via the Web Socket
      this.mSubject = this.mWebSocketService.connect(url);

      //Subscribe to the Web Socket so that the messages are recieved / converted / forwarded to listeners
      this.mSubscription = this.mSubject.subscribe(
        message => {
          console.log("Received Dialog WS Message: " + message.data);
          const dialogInstance = JSON.parse(message.data) as DialogInstance;
          console.log("Dialog Instance ID: " + dialogInstance.id + " - " + dialogInstance);

          //Fire off the Dialog Instance to any Event Listeners that are subscribed
          this.mDialogInstanceEventListeners.next(dialogInstance);
          this.mDialogNotificationService.getRefreshDialogsListener().next(true);
        }, 
        error => {
          console.error('Web Socket Error!', error);
        });
    }
  }

  public sendOnDemandDialogInstance(dialogInstance: DialogInstance): void {
    console.log("sendOnDemandDialogInstance() - Dialog Instance: " + (dialogInstance == null ? "*NULL*" : dialogInstance.id + "/" + (dialogInstance.dialog == null ? "*NULL_DIALOG*" : dialogInstance.dialog.name)));

    if (dialogInstance != null) {
      //Fire off the Dialog Instance to any Event Listeners that are subscribed
      this.dialogOnDemandEventListeners.next(dialogInstance);
    }
  }

}
